import { render, staticRenderFns } from "./TransferFiltrele.vue?vue&type=template&id=0a49b188"
import script from "./TransferFiltrele.vue?vue&type=script&lang=js"
export * from "./TransferFiltrele.vue?vue&type=script&lang=js"
import style0 from "./TransferFiltrele.vue?vue&type=style&index=0&id=0a49b188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports